const SITE_TEMPLATE = (import.meta.env.VITE_SITE_TEMPLATE || 'template2').toLowerCase();

export default SITE_TEMPLATE === 'template1' ? 'template1' : 'template2';
